import { prepareIon as _prepareIon } from '@buddy-technology/ion-helpers';
import setUpViews from './setUpViews';

const prepareION = (rawION) => {
	const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || null;
	// passing null here is ok, as it will require the helper to use computer time (as opposed to default of UTC)
	const convertedIon = _prepareIon(rawION, { shouldConvertRuleKeys: true, timezone });
	return setUpViews(convertedIon);
};

export default prepareION;
